import PlusLineIcon from "@/components/icons/plus-line"
import { Button } from "@/components/ui/button"
import BankAccountsTable from "./bank-accounts.table"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import BankAccountSheet from "./bank-account.sheet"
import InnerScreenHeader from "@/components/layout/inner-screen-header"
import { UserKycStatus, useUser } from "@/api/users"
import { useBankAccounts } from "@/api/bank-accounts"
import { buildKycRedirect } from "@/onboarding/kyc-requirement"

export default function BankAccountsScreen() {
  const { user } = useUser()
  const { bankAccountId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { bankAccounts } = useBankAccounts()

  if (!user || !bankAccounts) return null

  return (
    <div className="flex flex-col gap-6">
      <InnerScreenHeader title="Settings" to="/settings" tryBackFirst={false} />
      <div className="flex flex-row justify-between">
        <div className="text-xl font-semibold">Bank Accounts</div>
        <div className="flex flex-row gap-2">
          {/* <Button
            data-testid='link-bank-account'
            disabled={user.kycStatus !== UserKycStatus.SUCCESS}
            onClick={launchBankAccountLink}
          >
            <PlusLineIcon />
            Connect
          </Button> */}
          <Button
            data-testid="create-bank-account"
            onClick={() => {
              if (user.kycStatus !== UserKycStatus.SUCCESS) {
                const { url, state } = buildKycRedirect({ next: location.pathname })
                navigate(url, { state })
                return
              }
              navigate("/settings/bank-accounts/new")
            }}
          >
            <PlusLineIcon />
            Add Bank Account
          </Button>
        </div>
      </div>
      <BankAccountsTable />
      {bankAccountId && (
        <BankAccountSheet onClose={() => navigate("/settings/bank-accounts")} />
      )}
    </div>
  )
}
